module.exports = __webpack_public_path__ + "img/parallax.f6528f95.png";